import * as React from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import { useStoreActions } from 'easy-peasy';
import { Get } from '../services/http';
import RegularCampaign from './regular-campaign';
import GeneralCampaign from './general-campaign';

export default function CampaignPage() {
    const [activeTab, setActiveTab] = React.useState('');
    const showSpinner = useStoreActions((action) => action.showSpinner);
    const hideSpinner = useStoreActions((action) => action.hideSpinner);
    const { campaignID } = useParams();

    const getCampaignData = async () => {
        const projectData = await Get('/api/donation/GetCampaignType', { campaignID });
        if (projectData.result) {
            setActiveTab(projectData.campaignType);
            hideSpinner();
        }
    };

    React.useEffect(() => {
        getCampaignData();
        showSpinner();
    }, []);

    return (
        <>
            {activeTab === 'regular' ? (<RegularCampaign />) : ''}
            {activeTab === 'general' ? (<GeneralCampaign />) : ''}
        </>
    );
}
